const { createContext } = require("react");

export const IdUserContext = createContext();
